import React from 'react';

export type WithForwardedRefProps = {
  forwardedRef?: React.Ref<any>;
};

function withForwardedRef<P>(Component: React.ComponentType<P>) {
  return React.forwardRef((props: P, ref: React.Ref<any>) => <Component {...props} forwardedRef={ref} />);
}

export default withForwardedRef;
